// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-file-input[data-v-96bc0c64]{transition:all .2s ease-in-out}@media(prefers-reduced-motion:reduce){.v-file-input[data-v-96bc0c64]{transition:none}}.v-file-input__wrapper[data-v-96bc0c64]{display:flex}.v-file-input__file[data-v-96bc0c64]{height:.1px;opacity:0;overflow:hidden;position:absolute;width:.1px;z-index:-1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
